import { Badge } from '@/components/ui/badge';

interface TicketStatusBadgeProps {
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
}

const statusConfig = {
  open: {
    label: 'Aberto',
    className: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  },
  in_progress: {
    label: 'Em Andamento',
    className: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  },
  resolved: {
    label: 'Resolvido',
    className: 'bg-green-500/20 text-green-400 border-green-500/30',
  },
  closed: {
    label: 'Fechado',
    className: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  },
};

export const TicketStatusBadge = ({ status }: TicketStatusBadgeProps) => {
  const config = statusConfig[status];
  
  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  );
};
